import { render } from "./MbaMarkFin.vue?vue&type=template&id=386be2e2"
import script from "./MbaMarkFin.vue?vue&type=script&lang=js"
export * from "./MbaMarkFin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__